// define a mixin object
const apiMixin = {
  methods: {
    hasRole (role) {
      let roles = JSON.parse(this.$ls.get('role'))
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true
        }
      }
      return false
    },
    getClient (clientId) {
      this.clientPending = true
      this.$http.get('client/' + clientId).then(response => {
        this.client = response.data
        this.clientPending = false
      }, response => {
        this.clientError = response.body.error
        this.clientPending = false
      })
    },
    getDayVisits (getParams) {
      this.visitsPending = true
      this.$http.get('visit_day', { params: getParams }).then(response => {
        this.visits = response.data
        this.visitsPending = false
        this.visitsDone = true
      }).catch(error => {
        this.visitsError = error.response.data.errors
        this.visitsPending = false
      })
    },
    getDayVisitTasks (getParams) {
      this.visitsPending = true
      this.$http.get('visit_task/day', { params: getParams }).then(response => {
        this.visits = response.data
        this.visitsPending = false
      }).catch(error => {
        this.visitsError = error.response.data.errors
        this.visitsPending = false
      })
    },
    // getResults (getParams) {
    //   this.tasksPending = true
    //   this.$http.get('result', { params: getParams }).then(response => {
    //     console.log(response.data)
    //     this.tasks = response.data
    //     this.tasksPending = false
    //   }).catch(error => {
    //     this.tasksError = error.response.data.errors
    //     this.tasksPending = false
    //   })
    // },
    getAllergies (getParams) {
      this.getPaginatedList('allergy', getParams)
    },
    getResults (getParams) {
      this.getPaginatedList('result/new', getParams)
    },
    getDocuments (getParams) {
      this.getPaginatedList('document', getParams)
    },
    getContractualReports (getParams) {
      this.getPaginatedList('contractual_reports', getParams)
    },
    getTasks (getParams) {
      this.getPaginatedList('visit_task', getParams)
    },
    getPaginatedList (getUrl, getParams) {
      this.listPending = true
      this.$http.get(getUrl, { params: getParams }).then(response => {
        this.listPending = false
        this.listData = response.data.data
        this.listPagination = response.data.pagination || null
      }).catch(error => {
        this.listError = error.response.data.errors
        this.listPending = false
      })
    },
    getGenerateContractualReports (getParams) {
      this.generateContractualReportsPending = true
      this.generateContractualReportsDone = false
      this.$http.get('new_contractual_reporting_file', { params: getParams }).then(response => {
        this.generateContractualReports = response.data
        this.generateContractualReportsPending = false
        this.generateContractualReportsDone = true
      }).catch(error => {
        this.generateContractualReportsError = error.response.data.errors
        this.generateContractualReportsPending = false
        this.generateContractualReportsDone = false
      })
    },
    deleteContractualReport (id) {
      this.deleteContractualReportPending = true
      this.$http.delete('contractual_report/' + id, {emulateJSON: true}).then(response => {
        this.deleteContractualReportPending = false
        this.deleteContractualReportDone = true
      }).catch(error => {
        this.deleteContractualReportError = error.response.data.errors
        this.deleteContractualReportPending = false
      })
    },
    getMonthStatistics (getParams) {
      this.monthStatisticsPending = true
      this.monthStatisticsDone = false
      this.$http.get('statistics/month', { params: getParams }).then(response => {
        this.monthStatistics = response.data
        this.monthStatisticsPending = false
        this.monthStatisticsDone = true
      }).catch(error => {
        this.monthStatisticsError = error.response.data.errors
        this.monthStatisticsPending = false
        this.monthStatisticsDone = false
      })
    },
    getTasksOld (getParams) {
      this.tasksPending = true
      this.$http.get('task_for_medic', { params: getParams }).then(response => {
        this.tasks = response.data
        this.tasksPending = false
      }).catch(error => {
        this.tasksError = error.response.data.errors
        this.tasksPending = false
        this.tasks = false
      })
    },
    getTasksCreatedByMedic (getParams) {
      this.tasksPending = true
      this.$http.get('task_created_by_medic', { params: getParams }).then(response => {
        this.tasks = response.data
        this.tasksPending = false
      }).catch(error => {
        this.tasksError = error.response.data.errors
        this.tasksPending = false
        this.tasks = false
      })
    },
    getClientsTasks (getParams, clientId) {
      this.tasksPending = true
      this.$http.get('client/' + clientId + '/tasks', { params: getParams }).then(response => {
        this.tasks = response.data
        this.tasksPending = false
      }).catch(error => {
        this.tasksError = error.response.data.errors
        this.tasksPending = false
      })
    },
    getTaskTemplates () {
      this.waitForData = true
      this.$http.get('task_template').then(response => {
        this.taskTemplates = response.data
        this.waitForData = false
      }).catch(error => {
        this.taskTemplatesError = error.response.data.errors
        this.waitForData = false
      })
    },
    getMedics () {
      this.waitForData = true
      this.$http.get('medic').then(response => {
        this.medics = response.data
        this.waitForData = false
      }).catch(error => {
        this.medicsError = error.response.data.errors
        this.waitForData = false
      })
    },
    getClientPreviousTasks (getParams) {
      this.clientPreviousTasksPending = true
      this.$http.get('result', { params: getParams }).then(response => {
        this.clientPreviousTasks = response.data
        this.clientPreviousTasksPending = false
      }).catch(error => {
        this.clientPreviousTasksError = error.response.data.errors
        this.clientPreviousTasksPending = false
      })
    },
    getMedicalReportOfClient (clientId) {
      this.medicalReportsPending = true
      this.$http.get('client/' + clientId + '/medical_report').then(response => {
        this.medicalReports = response.data
        this.medicalReportsPending = false
      }).catch(error => {
        this.medicalReportsError = error.response.data.errors
        this.medicalReportsPending = false
      })
    },
    getMedicalReportAndLabResultOfClient (clientId, exceptVisitId) {
      this.tasksPending = true
      this.$http.get('client/' + clientId + '/medical_report_lab_result', { params: {'visit_id': exceptVisitId} }).then(response => {
        this.tasks = response.data
        this.tasksPending = false
      }).catch(error => {
        this.tasksError = error.response.data.errors
        this.tasksPending = false
      })
    },
    getClientAnamnesisByVisit (visitId) {
      this.clientAnamnesisPending = true
      this.clientAnamnesisDone = false
      this.$http.get('visit/' + visitId + '/anamnesis').then(response => {
        this.clientAnamnesis = response.data
        this.clientAnamnesisPending = false
        this.clientAnamnesisDone = true
      }).catch(error => {
        this.clientAnamnesisError = error.response.data.errors
        this.clientAnamnesisPending = false
        this.clientAnamnesisDone = false
      })
    },
    getActualClientAnamnesis (clientId) {
      this.actualClientAnamnesisPending = true
      this.actualClientAnamnesisDone = false
      this.$http.get('client/' + clientId + '/actual_anamnesis').then(response => {
        this.actualClientAnamnesis = response.data
        this.actualClientAnamnesisPending = false
        this.actualClientAnamnesisDone = true
      }).catch(error => {
        this.actualClientAnamnesisError = error.response.data.errors
        this.actualClientAnamnesisPending = false
        this.actualClientAnamnesisDone = false
      })
    },
    getWeekCalendarForDoctor (medicId, getParams) {
      this.calendarPending = true
      this.$http.get('medic/' + medicId + '/calendar', { params: getParams }).then(response => {
        this.calendar = response.data
        this.calendarPending = false
      }).catch(error => {
        this.calendarError = error.response.data.errors
        this.calendarPending = false
      })
    },
    getWeekVisitsForDoctor (medicId, getParams) {
      this.visitsPending = true
      this.$http.get('medic/' + medicId + '/visit', { params: getParams }).then(response => {
        this.visits = response.data
        this.visitsPending = false
      }).catch(error => {
        this.visitsError = error.response.data.errors
        this.visitsPending = false
      })
    },
    getFreeTimeForDoctor (medicId, getParams) {
      this.freeTimePending = true
      this.$http.get('medic/' + medicId + '/free', { params: getParams }).then(response => {
        this.freeTime = response.data
        this.freeTimePending = false
      }).catch(error => {
        this.freeTimeError = error.response.data.errors
        this.freeTimePending = false
      })
    },
    getDoctorsLeisureTime (medicId) {
      this.leisureTimePending = true
      this.$http.get('medic/' + medicId + '/leisure_time').then(response => {
        this.leisureTime = response.data
        this.leisureTimePending = false
      }).catch(error => {
        this.leisureTimeError = error.response.data.errors
        this.leisureTimePending = false
      })
    },
    getResultInfo (hash) {
      this.resultInfoDone = false
      this.resultInfoPending = true
      this.$http.get('cd/auth', { params: { 'hash': hash } }).then(response => {
        this.resultInfo = response.data
        this.resultInfoPending = false
        this.resultInfoDone = true
      }).catch(error => {
        this.resultInfoError = error.response.data
        this.resultInfoPending = false
      })
    },
    postResultVerify (authForm) {
      this.resultVerifyDone = true
      this.$http.post('cd/verify', authForm, {emulateJSON: true}).then(response => {
        this.result = response.data
        this.resultVerifyPending = false
        this.resultVerifyDone = true
        this.resultAuthError = false
      }).catch(error => {
        this.resultAuthError = error.response.data.error
        this.resultVerifyPending = false
      })
    },
    postLeisureTime (leisureTime, doctorId) {
      this.newLeisureTimePending = true
      this.$http.post('medic/' + doctorId + '/leisure_time', leisureTime, {emulateJSON: true}).then(response => {
        this.newLeisureTimePending = false
        this.newLeisureTimeDone = true
      }).catch(error => {
        this.newLeisureTimeError = error.response.data.errors
        this.newLeisureTimePending = false
      })
    },
    postTask (task, clientId) {
      this.newTaskPending = true
      this.$http.post('client/' + clientId + '/task', task, {emulateJSON: true}).then(response => {
        this.newTaskPending = false
        this.newTaskDone = true
      }).catch(error => {
        this.newTaskError = error.response.data.errors
        this.newTaskPending = false
      })
    },
    putLeisureTime (leisureTime) {
      this.updatedLeisureTimePending = true
      this.$http.put('leisure_time/' + leisureTime.id, leisureTime, {emulateJSON: true}).then(response => {
        this.updatedLeisureTimePending = false
        this.updatedLeisureTimeDone = true
      }).catch(error => {
        this.updatedLeisureTimeError = error.response.data.errors
        this.updatedLeisureTimePending = false
      })
    },
    deleteLeisureTime (leisureTimeId) {
      this.deleteLeisureTimePending = true
      this.$http.delete('leisure_time/' + leisureTimeId, {emulateJSON: true}).then(response => {
        this.deleteLeisureTimePending = false
        this.deleteLeisureTimeDone = true
      }).catch(error => {
        this.deleteLeisureTimeError = error.response.data.errors
        this.deleteLeisureTimePending = false
      })
    },
    deleteInsurance (insuranceId) {
      this.deleteInsurancePending = true
      this.$http.delete('insurance/' + insuranceId, {emulateJSON: true}).then(response => {
        this.deleteInsurancePending = false
        this.deleteInsuranceDone = true
      }).catch(error => {
        this.deleteInsuranceError = error.response.data.errors
        this.deleteInsurancePending = false
      })
    },
    deleteMembership (membershipId) {
      this.deleteMembershipPending = true
      this.$http.delete('membership/' + membershipId, {emulateJSON: true}).then(response => {
        this.deleteMembershipPending = false
        this.deleteMembershipDone = true
      }).catch(error => {
        this.deleteMembershipError = error.response.data.errors
        this.deleteMembershipPending = false
      })
    },
    deleteElectronicPrescription (ep) {
      let params = {}
      if (ep.reason) {
        params = {reason: ep.reason}
      }
      this.deleteElectronicPrescriptionPending = true
      this.$http.delete('prescription_electronic/' + ep.id, { params: params }).then(response => {
        this.deleteElectronicPrescriptionPending = false
        this.deleteElectronicPrescriptionDone = true
      }).catch(error => {
        this.deleteElectronicPrescriptionError = error.response.data.errors
        this.deleteElectronicPrescriptionPending = false
      })
    },
    sendToSuklElectronicPrescription (electronicPrescriptionId) {
      this.sendToSuklElectronicPrescriptionPending = true
      this.$http.post('electronic_prescription/' + electronicPrescriptionId + '/send', {emulateJSON: true}).then(response => {
        this.sendToSuklElectronicPrescriptionPending = false
        this.sendToSuklElectronicPrescriptionDone = true
      }).catch(error => {
        this.sendToSuklElectronicPrescriptionError = error.response.data.errors
        this.sendToSuklElectronicPrescriptionPending = false
      })
    },
    sendToSuklElectronicVoucher (electronicVoucherId) {
      this.sendToSuklElectronicVoucherPending = true
      this.$http.post('electronic_voucher/' + electronicVoucherId + '/send', {emulateJSON: true}).then(response => {
        this.sendToSuklElectronicVoucherPending = false
        this.sendToSuklElectronicVoucherDone = true
      }).catch(error => {
        this.sendToSuklElectronicVoucherError = error.response.data.errors
        this.sendToSuklElectronicVoucherPending = false
      })
    },
    deleteElectronicVoucher (ep) {
      let params = {}
      if (ep.reason) {
        params = {reason: ep.reason}
      }
      this.deleteElectronicVoucherPending = true
      this.$http.delete('voucher_electronic/' + ep.id, { params: params }).then(response => {
        this.deleteElectronicVoucherPending = false
        this.deleteElectronicVoucherDone = true
      }).catch(error => {
        this.deleteElectronicVoucherError = error.response.data.errors
        this.deleteElectronicVoucherPending = false
      })
    },
    getDoctorsWorkingTime (medicId) {
      this.workingTimePending = true
      this.$http.get('medic/' + medicId + '/working_time').then(response => {
        this.workingTime = response.data
        this.workingTimePending = false
      }).catch(error => {
        this.workingTimeError = error.response.data.errors
        this.workingTimePending = false
      })
    },
    postWorkingTime (workingTime, doctorId) {
      this.newWorkingTimePending = true
      this.$http.post('medic/' + doctorId + '/working_time', workingTime, {emulateJSON: true}).then(response => {
        this.newWorkingTimePending = false
        this.newWorkingTimeDone = true
      }).catch(error => {
        this.newWorkingTimeError = error.response.data.errors
        this.newWorkingTimePending = false
      })
    },
    putWorkingTime (workingTime) {
      this.updatedWorkingTimePending = true
      this.$http.put('working_time/' + workingTime.id, workingTime, {emulateJSON: true}).then(response => {
        this.updatedWorkingTimePending = false
        this.updatedWorkingTimeDone = true
      }).catch(error => {
        this.updatedWorkingTimeError = error.response.data.errors
        this.updatedWorkingTimePending = false
      })
    },
    deleteWorkingTime (workingTimeId) {
      this.deleteWorkingTimePending = true
      this.$http.delete('working_time/' + workingTimeId, {emulateJSON: true}).then(response => {
        this.deleteWorkingTimePending = false
        this.deleteWorkingTimeDone = true
      }).catch(error => {
        this.deleteWorkingTimeError = error.response.data.errors
        this.deleteWorkingTimePending = false
      })
    },
    getClientsVisits (states, clientId) {
      let getParams = {
        states: JSON.stringify(states)}
      this.visitsPending = true
      this.$http.get('client/' + clientId + '/visit', { params: getParams }).then(response => {
        this.visits = response.data
        this.visitsPending = false
      }).catch(error => {
        this.visitsError = error.response.data.errors
        this.visitsPending = false
      })
    },
    getClientsVisitTasks (states, clientId) {
      let getParams = {
        states: JSON.stringify(states)}
      this.visitsPending = true
      this.$http.get('client/' + clientId + '/visit_task', { params: getParams }).then(response => {
        this.visits = response.data
        this.visitsPending = false
      }).catch(error => {
        this.visitsError = error.response.data.errors
        this.visitsPending = false
      })
    },
    postVisit (visit) {
      this.visitPending = true
      this.$http.post('visit', visit, {emulateJSON: true}).then(response => {
        this.visitPending = false
        this.visitDone = true
      }).catch(error => {
        this.visitError = error.response.data.errors
        this.visitPending = false
      })
    },
    putVisit (id, visit, filter = null) {
      visit = (filter !== null ? this.filterData(visit, filter) : visit)
      this.putVisitPending = true
      this.$http.put('visit/' + id, visit, {emulateJSON: true}).then(response => {
        this.putVisitPending = false
        this.putVisitDone = true
      }).catch(error => {
        this.putVisitError = error.response.data.errors
        this.putVisitPending = false
      })
    },
    filterData (data, includeFilter) {
      Object.keys(data).forEach(function (key, index) {
        if (includeFilter.indexOf(key) < 0) {
          delete data[key]
        }
      })
      return data
    },
    postVisitTask (visit) {
      this.visitPending = true
      this.$http.post('visit_task', visit, {emulateJSON: true}).then(response => {
        this.visitPending = false
        this.visitDone = true
      }).catch(error => {
        this.visitError = error.response.data.errors
        this.visitPending = false
      })
    },
    getVisit (visitId) {
      this.visitPending = true
      this.$http.get('visit/' + visitId, {emulateJSON: true}).then(response => {
        this.visitPending = false
        this.visit = response.data
        // return response.data
      }).catch(error => {
        this.visitError = error.response.data.errors
        this.visitPending = false
      })
    },
    getInsuranceCompanies () {
      this.insuranceCompaniesPending = true
      this.$http.get('insurance_companies').then(response => {
        this.insuranceCompanies = response.data
        this.insuranceCompaniesPending = false
      }, response => {
        this.insuranceCompaniesError = response.body.error
        this.insuranceCompaniesPending = false
      })
    },
    getPrograms () {
      this.programsPending = true
      this.$http.get('programs').then(response => {
        this.programs = response.data
        this.programsPending = false
      }).catch(error => {
        this.programsError = error.response.data.errors
        this.programsPending = false
      })
    },
    getDoctors () {
      this.doctorsPending = true
      this.$http.get('doctor').then(response => {
        this.doctors = response.data
        this.doctorsPending = false
      }).catch(error => {
        this.doctorsError = error.response.data.errors
        this.doctorsPending = false
      })
    },
    getBranches () {
      this.branchesPending = true
      this.$http.get('branch').then(response => {
        this.branches = response.data
        this.branchesPending = false
      }).catch(error => {
        this.branchesError = error.response.data.errors
        this.branchesPending = false
      })
    },
    getVisitPurposes () {
      this.visitPurposesPending = true
      this.$http.get('visit_purpose').then(response => {
        this.visitPurposes = response.data
        this.visitPurposesPending = false
        this.visitPurposesDone = true
      }).catch(error => {
        this.visitPurposeError = error.response.data.errors
        this.visitPurposesPending = false
      })
    },
    getDiagnosisTemplates () {
      this.diagnosisTemplatesPending = true
      this.$http.get('diagnosis_templates').then(response => {
        this.diagnosisTemplates = response.data
        this.diagnosisTemplatesPending = false
      }).catch(error => {
        this.diagnosisTemplatesError = error.response.data.errors
        this.diagnosisTemplatesPending = false
      })
    },
    postInsurance (clientId) {
      this.insurancePending = true
      this.$http.post('client/' + clientId + '/insurance', this.insurance, {emulateJSON: true}).then(response => {
        this.insurancePending = false
        this.insuranceDone = true
      }).catch(error => {
        this.insuranceError = error.response.data.errors
        this.insurancePending = false
      })
    },
    postMembership (clientId) {
      let membership = JSON.parse(JSON.stringify(this.membership))
      membership.valid_from = this.$moment(membership.valid_from).format('DD.MM.YYYY')
      membership.valid_to = this.$moment(membership.valid_to).format('DD.MM.YYYY')
      this.membershipPending = true
      this.$http.post('client/' + clientId + '/membership', membership, {emulateJSON: true}).then(response => {
        this.membershipPending = false
        this.membershipDone = true
      }).catch(error => {
        this.membershipError = error.response.data.errors
        this.membershipPending = false
      })
    },
    putMembership (membershipId) {
      let membership = JSON.parse(JSON.stringify(this.membershipToUpdate))
      membership.valid_from = this.$moment(membership.valid_from).format('DD.MM.YYYY')
      membership.valid_to = this.$moment(membership.valid_to).format('DD.MM.YYYY')
      this.updateMembershipPending = true
      this.$http.put('membership/' + membershipId + '/update', membership, {emulateJSON: true}).then(response => {
        this.updateMembershipPending = false
        this.updateMembershipDone = true
      }).catch(error => {
        this.updateMembershipError = error.response.data.errors
        this.updateMembershipPending = false
      })
    },
    getCitizenship () {
      this.citizenshipPending = true
      this.$http.get('citizenship').then(response => {
        this.citizenship = response.data
        this.citizenshipPending = false
      }).catch(error => {
        this.citizenshipError = error.response.data.errors
        this.citizenshipPending = false
      })
    },
    getCountries () {
      this.countriesPending = true
      this.$http.get('country').then(response => {
        this.countries = response.data
        this.countriesPending = false
      }).catch(error => {
        this.countriesError = error.response.data.errors
        this.countriesPending = false
      })
    },
    getClientInsurances (clientId) {
      this.clientInsurancesPending = true
      this.$http.get('client/' + clientId + '/insurance').then(response => {
        this.clientInsurances = response.data
        this.clientInsurancesPending = false
      }).catch(error => {
        this.clientInsurancesError = error.response.data.errors
        this.clientInsurancesPending = false
      })
    },
    getClientMemberships (clientId) {
      this.clientMembershipsPending = true
      this.$http.get('client/' + clientId + '/membership').then(response => {
        this.clientMemberships = response.data
        this.clientMembershipsPending = false
      }).catch(error => {
        this.clientMemberships = null
        this.clientMembershipsError = error.response.data.errors
        this.clientMembershipsPending = false
      })
    },
    putClient (client) {
      this.clientPending = true
      this.$http.put('client/' + client.id, client, {emulateJSON: true}).then(response => {
        this.clientPending = false
        this.clientDone = true
      }).catch(error => {
        this.clientError = error.response.data.errors
        this.clientPending = false
      })
    },
    putAddress (address) {
      this.addressPending = true
      this.$http.put('address/' + address.id, address, {emulateJSON: true}).then(response => {
        this.addressPending = false
        this.addressDone = true
      }).catch(error => {
        this.addressError = error.response.data.errors
        this.addressPending = false
      })
    },
    postAddress (address, clientId) {
      this.addressPending = true
      this.$http.post('client/' + clientId + '/address', address, {emulateJSON: true}).then(response => {
        this.addressPending = false
        this.addressDone = true
      }).catch(error => {
        this.addressError = error.response.data.errors
        this.addressPending = false
      })
    },
    postEmailAddress (emailAddress, clientId) {
      this.newEmailAddressPending = true
      this.$http.post('client/' + clientId + '/email_address', emailAddress, {emulateJSON: true}).then(response => {
        this.newEmailAddressPending = false
        this.newEmailAddressDone = true
      }).catch(error => {
        this.newEmailAddressError = error.response.data.errors
        this.newEmailAddressPending = false
      })
    },
    putEmailAddress (emailAddress) {
      this.updatedEmailAddressPending = true
      this.$http.put('email_address/' + emailAddress.id, emailAddress, {emulateJSON: true}).then(response => {
        this.updatedEmailAddressPending = false
        this.updatedEmailAddressDone = true
      }).catch(error => {
        this.updatedEmailAddressError = error.response.data.errors
        this.updatedEmailAddressPending = false
      })
    },
    deleteEmailAddress (emailAddressId) {
      this.deleteEmailAddressPending = true
      this.$http.delete('email_address/' + emailAddressId, {emulateJSON: true}).then(response => {
        this.deleteEmailAddressPending = false
        this.deleteEmailAddressDone = true
      }).catch(error => {
        this.deleteEmailAddressError = error.response.data.errors
        this.deleteEmailAddressPending = false
      })
    },
    postPhoneNumber (phoneNumber, clientId) {
      this.newPhoneNumberPending = true
      this.$http.post('client/' + clientId + '/phone_number', phoneNumber, {emulateJSON: true}).then(response => {
        this.newPhoneNumberPending = false
        this.newPhoneNumberDone = true
      }).catch(error => {
        this.newPhoneNumberError = error.response.data.errors
        this.newPhoneNumberPending = false
      })
    },
    putPhoneNumber (phoneNumber) {
      this.updatedPhoneNumberPending = true
      this.$http.put('phone_number/' + phoneNumber.id, phoneNumber, {emulateJSON: true}).then(response => {
        this.updatedPhoneNumberPending = false
        this.updatedPhoneNumberDone = true
      }).catch(error => {
        this.updatedPhoneNumberError = error.response.data.errors
        this.updatedPhoneNumberPending = false
      })
    },
    deletePhoneNumber (phoneNumberId) {
      this.deletePhoneNumberPending = true
      this.$http.delete('phone_number/' + phoneNumberId, {emulateJSON: true}).then(response => {
        this.deletePhoneNumberPending = false
        this.deletePhoneNumberDone = true
      }).catch(error => {
        this.deletePhoneNumberError = error.response.data.errors
        this.deletePhoneNumberPending = false
      })
    },
    deleteDocument (documentId) {
      this.documentDeleteError = null
      this.documentDeleteDone = false
      this.documentDeletePending = true
      this.$http.delete('document/' + documentId, {emulateJSON: true}).then(response => {
        this.documentDeletePending = false
        this.documentDeleteDone = true
      }).catch(error => {
        this.documentDeleteError = error.response.data.errors
        this.documentDeletePending = false
      })
    },
    postGdprConsent (gdprConsent, clientId) {
      this.newGdprConsentPending = true
      this.$http.post('client/' + clientId + '/gdpr_consent', gdprConsent, {emulateJSON: true}).then(response => {
        this.newGdprConsentPending = false
        this.newGdprConsentDone = true
      }).catch(error => {
        this.newGdprConsentError = error.response.data.errors
        this.newGdprConsentPending = false
      })
    },
    putGdprConsent (gdprConsent) {
      this.updatedGdprConsentPending = true
      this.$http.put('gdpr_consent/' + gdprConsent.id, gdprConsent, {emulateJSON: true}).then(response => {
        this.updatedGdprConsentPending = false
        this.updatedGdprConsentDone = true
      }).catch(error => {
        this.updatedGdprConsentError = error.response.data.errors
        this.updatedGdprConsentPending = false
      })
    },
    deleteGdprConsent (gdprConsentId) {
      this.deleteGdprConsentPending = true
      this.$http.delete('gdpr_consent/' + gdprConsentId, {emulateJSON: true}).then(response => {
        this.deleteGdprConsentPending = false
        this.deleteGdprConsentDone = true
      }).catch(error => {
        this.deleteGdprConsentError = error.response.data.errors
        this.deleteGdprConsentPending = false
      })
    },
    searchOperations (searchParams) {
      this.operationsPending = true
      this.$http.get('szv/operation', { params: searchParams }).then(response => {
        if (response.status === 204) {
          this.operations = []
        } else {
          this.operations = response.data
        }
        this.operationsPending = false
      }).catch(error => {
        this.operations = []
        this.operationsError = error.response.data.errors
        this.operationsPending = false
      })
    },
    postDiagnosis (visitId, diagnosis) {
      this.diagnosisPending = true
      this.$http.post('visit/' + visitId + '/diagnosis', diagnosis, {emulateJSON: true}).then(response => {
        this.diagnosisPending = false
        this.diagnosisDone = true
      }).catch(error => {
        this.diagnosisError = error.response.data.errors
        this.diagnosisPending = false
      })
    },
    postDiagnosisTemplate (visitId, diagnosisTemplateId) {
      this.diagnosisTemplatePending = true
      this.$http.post('visit/' + visitId + '/diagnosis_template', {'diagnosis_template_id': diagnosisTemplateId}, {emulateJSON: true}).then(response => {
        this.diagnosisTemplatePending = false
        this.diagnosisTemplateDone = true
      }).catch(error => {
        this.diagnosisTemplateError = error.response.data.errors
        this.diagnosisTemplatePending = false
      })
    },
    postMedicament (medicament, clientId, visitId = null) {
      this.medicamentPending = true
      if (visitId !== null) {
        medicament.visit_id = visitId
      }
      this.$http.post('client/' + clientId + '/medicament', medicament, {emulateJSON: true}).then(response => {
        this.medicamentPending = false
        this.medicamentDone = true
      }).catch(error => {
        this.medicamentError = error.response.data.errors
        this.medicamentPending = false
      })
    },
    postVoucher (voucher, clientId, visitId = null) {
      this.voucherPending = true
      if (visitId !== null) {
        voucher.visit_id = visitId
      }
      this.$http.post('client/' + clientId + '/voucher', voucher, {emulateJSON: true}).then(response => {
        this.voucherPending = false
        this.voucherDone = true
      }).catch(error => {
        this.voucherError = error.response.data.errors
        this.voucherPending = false
      })
    },
    searchSimilarMedicineByMedicament (medicament) {
      this.searchSimilarMedicinePending = true
      this.$http.post('sukl/similar_medicine', medicament, {emulateJSON: true}).then(response => {
        this.searchSimilarMedicinePending = false
        this.searchSimilarMedicineDone = true
      }).catch(error => {
        this.searchSimilarMedicineError = error.response.data.errors
        this.searchSimilarMedicinePending = false
      })
    },
    deleteDiagnosis (diagnosisId) {
      this.deleteDiagnosisPending = true
      this.$http.delete('diagnosis/' + diagnosisId, {emulateJSON: true}).then(response => {
        this.deleteDiagnosisPending = false
        this.deleteDiagnosisDone = true
      }).catch(error => {
        this.deleteDiagnosisError = error.response.data.errors
        this.deleteDiagnosisPending = false
      })
    },
    deleteMedicament (medicamentId) {
      this.deleteMedicamentPending = true
      this.$http.delete('medicament/' + medicamentId, {emulateJSON: true}).then(response => {
        this.deleteMedicamentPending = false
        this.deleteMedicamentDone = true
      }).catch(error => {
        this.deleteMedicamentError = error.response.data.errors
        this.deleteMedicamentPending = false
      })
    },
    postAction (diagnosisId, action) {
      this.actionPending = true
      this.$http.post('diagnosis/' + diagnosisId + '/action', action, {emulateJSON: true}).then(response => {
        this.actionPending = false
        this.actionDone = true
      }).catch(error => {
        this.actionError = error.response.data.errors
        this.actionPending = false
      })
    },
    deleteAction (actionId) {
      this.deleteActionPending = true
      this.$http.delete('action/' + actionId, {emulateJSON: true}).then(response => {
        this.deleteActionPending = false
        this.deleteActionDone = true
      }).catch(error => {
        this.deleteActionError = error.response.data.errors
        this.deleteActionPending = false
      })
    },
    checkOperationLimitation (operationCode, visitId) {
      let getParams = {
        visit: visitId
      }
      this.operationLimitationPending = true
      this.$http.get('/action_check/' + operationCode, { params: getParams }).then(response => {
        this.operationLimitation = response.data
        this.operationLimitationPending = false
      }).catch(error => {
        this.operationLimitationError = error.response.data.errors
        this.operationLimitationPending = false
      })
    },
    postZulp (actionId, zulp) {
      this.zulpPending = true
      this.$http.post('action/' + actionId + '/zulp', zulp, {emulateJSON: true}).then(response => {
        this.zulpPending = false
        this.zulpDone = true
      }).catch(error => {
        this.zulpError = error.response.data.errors
        this.zulpPending = false
      })
    },
    deleteZulp (zulpId) {
      this.deletZulpPending = true
      this.$http.delete('zulp/' + zulpId, {emulateJSON: true}).then(response => {
        this.deletZulpPending = false
        this.deletZulpDone = true
      }).catch(error => {
        this.deletZulpError = error.response.data.errors
        this.deletZulpPending = false
      })
    },
    postZum (actionId, zum) {
      this.zumPending = true
      this.$http.post('action/' + actionId + '/zum', zum, {emulateJSON: true}).then(response => {
        this.zumPending = false
        this.zumDone = true
      }).catch(error => {
        this.zumError = error.response.data.errors
        this.zumPending = false
      })
    },
    deleteZum (zumId) {
      this.deletZumPending = true
      this.$http.delete('zum/' + zumId, {emulateJSON: true}).then(response => {
        this.deletZumPending = false
        this.deletZumDone = true
      }).catch(error => {
        this.deletZumError = error.response.data.errors
        this.deletZumPending = false
      })
    },
    decodePIN (pin) {
      this.birthDateCalculated = false
      this.decodePinPending = true
      this.decodePinWarning = false
      this.$http.get('validatepin', {params: {pin: pin}}).then(response => {
        if (response.data.birth_date) {
          this.clientForm.gender = response.data.gender
          this.clientForm.birth_date = response.data.birth_date
          this.birthDateCalculated = true
        }
        this.decodePinWarning = response.data.warning
        this.parsePinMessage = ''
        this.decodePinPending = false
      }).catch(error => {
        this.decodePinError = error.response.data.errors
        this.decodePinPending = false
      })
    },
    getClientMedicineInfo (clientId, medicineCode) {
      this.clientMedicineInfoPending = true
      this.clientMedicineInfoDone = false
      this.$http.get('client/' + clientId + '/medicine/' + medicineCode).then(response => {
        this.clientMedicineInfo = response.data
        this.clientMedicineInfoPending = false
        this.clientMedicineInfoDone = true
      }).catch(error => {
        this.clientMedicineInfoError = error.response.data.errors
        this.clientMedicineInfoPending = false
      })
    },
    getClientMedicalDeviceInfo (clientId, medicineCode) {
      this.clientMedicalDeviceInfoPending = true
      this.clientMedicalDeviceInfoDone = false
      this.$http.get('client/' + clientId + '/medicine/' + medicineCode).then(response => {
        this.clientMedicalDeviceInfo = response.data
        this.clientMedicalDeviceInfoPending = false
        this.clientMedicalDeviceInfoDone = true
      }).catch(error => {
        this.clientMedicalDeviceInfoError = error.response.data.errors
        this.clientMedicalDeviceInfoPending = false
      })
    },
    getClientIndividualMedicineInfo (clientId, medicineId) {
      this.clientMedicineInfoPending = true
      this.clientMedicineInfoDone = false
      this.$http.get('client/' + clientId + '/individual_medicine/' + medicineId).then(response => {
        this.clientMedicineInfo = response.data
        this.clientMedicineInfoPending = false
        this.clientMedicineInfoDone = true
      }).catch(error => {
        this.clientMedicineInfoError = error.response.data.errors
        this.clientMedicineInfoPending = false
      })
    },
    getMedicines (searchText) {
      if (searchText.length > 2) {
        this.medicinesPending = true
        this.$http.get('sukl/medicine', {params: {search: searchText}}).then(response => {
          if (response.status === 204) {
            this.medicines = []
          } else {
            this.medicines = response.data
          }
          this.medicinesPending = false
        }).catch(error => {
          this.medicines = []
          this.medicinesError = error.response.data.errors
          this.medicinesPending = false
        })
      }
    },
    getMedicalDevices (searchText) {
      if (searchText.length > 2) {
        this.medicalDevicesPending = true
        this.$http.get('szp/medical_device', {params: {search: searchText}}).then(response => {
          if (response.status === 204) {
            this.medicalDevices = []
          } else {
            this.medicalDevices = response.data
          }
          this.medicalDevicesPending = false
        }).catch(error => {
          this.medicalDevices = []
          this.medicalDevicesError = error.response.data.errors
          this.medicalDevicesPending = false
        })
      }
    },
    getIndividualMedicines (searchText) {
      if (searchText.length > 2) {
        this.individualMedicinesPending = true
        this.$http.get('individual_medicine/search', {params: {search: searchText}}).then(response => {
          if (response.status === 204) {
            this.individualMedicines = []
          } else {
            this.individualMedicines = response.data
          }
          this.individualMedicinesPending = false
        }).catch(error => {
          this.individualMedicines = []
          this.individualMedicinesError = error.response.data.errors
          this.individualMedicinesPending = false
        })
      }
    },
    getMaterials (searchText) {
      if (searchText.length > 2) {
        this.materialsPending = true
        this.$http.get('zum/material', {params: {search: searchText}}).then(response => {
          if (response.status === 204) {
            this.materials = []
          } else {
            this.materials = response.data
          }
          this.materialsPending = false
        }).catch(error => {
          this.materials = []
          this.materialsError = error.response.data.errors
          this.materialsPending = false
        })
      }
    },
    searchAddresses (searchText) {
      if (searchText.length > 3) {
        this.searchAddressesPending = true
        this.$http.get('search_address', {params: {search: searchText}}).then(response => {
          this.addresses = response.data
          this.searchAddressesPending = false
        }).catch(error => {
          this.searchAddresses = []
          this.searchAddressesError = error.response.data.errors
          this.searchAddressesPending = false
        })
      }
    },
    searchForeignAddresses (searchText) {
      if (searchText.length > 3) {
        this.searchForeignAddressesPending = true
        this.$http.get('search_foreign_address', {params: {search: searchText}}).then(response => {
          this.foreignAddresses = response.data
          this.searchForeignAddressesPending = false
        }).catch(error => {
          this.searchForeignAddresses = []
          this.searchForeignAddressesError = error.response.data.errors
          this.searchForeignAddressesPending = false
        })
      }
    },
    getForeignAddressDetail (placeId) {
      this.foreignAddressDetailPending = true
      this.foreignAddressDetailDone = false
      this.$http.get('load_foreign_address', {params: {place_id: placeId}}).then(response => {
        this.foreignAddressDetail = response.data
        this.foreignAddressDetailPending = false
        this.foreignAddressDetailDone = true
      }).catch(error => {
        this.foreignAddressDetail = false
        this.foreignAddressDetailError = error.response.data.errors
        this.foreignAddressDetailPending = false
        this.foreignAddressDetailDone = false
      })
    },
    userHasRole (role) {
      console.log('role:' + this.$ls.get('role'))
      let roles = JSON.parse(this.$ls.get('role'))
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true
        }
      }
      return false
    },
    searchClients (text) {
      this.clientsPending = true
      this.$http.get('search', {
        params: {text: text}
      }).then(response => {
        this.clients = response.data
        this.clientsPending = false
      }).catch(error => {
        this.clientsPending = false
        this.clientsError = error.response.data.errors
      })
    },
    getPrescriptions (visitId) {
      this.prescriptionsPending = true
      this.$http.get('visit/' + visitId + '/prescription').then(response => {
        this.prescriptions = response.data
        this.prescriptionsPending = false
      }).catch(error => {
        this.prescriptionsError = error.response.data.errors
        this.prescriptions = false
        this.prescriptionsPending = false
      })
    },
    getClientPrescriptions (clientId, filterDate = false) {
      this.prescriptionsPending = true
      this.$http.get('client/' + clientId + '/prescription?filter_date=' + filterDate).then(response => {
        this.prescriptions = response.data
        this.prescriptionsPending = false
      }).catch(error => {
        this.prescriptionsError = error.response.data.errors
        this.prescriptions = false
        this.prescriptionsPending = false
      })
    },
    getVouchers (visitId) {
      this.vouchersPending = true
      this.$http.get('visit/' + visitId + '/voucher').then(response => {
        this.vouchers = response.data
        this.vouchersPending = false
      }).catch(error => {
        this.vouchersError = error.response.data.errors
        this.vouchers = false
        this.vouchersPending = false
      })
    },
    getClientVouchers (clientId, filterDate = false) {
      this.vouchersPending = true
      this.$http.get('client/' + clientId + '/voucher?filter_date=' + filterDate).then(response => {
        this.vouchers = response.data
        this.vouchersPending = false
      }).catch(error => {
        this.vouchersError = error.response.data.errors
        this.vouchers = false
        this.vouchersPending = false
      })
    },
    getClientMedicaments (clientId, exceptVisitId = false, filterDate = false) {
      this.medicamentsPending = true
      this.medicamentsDone = false
      this.$http.get('client/' + clientId + '/medicament?except_visit=' + exceptVisitId + '&filter_date=' + filterDate).then(response => {
        this.medicaments = response.data
        this.medicamentsPending = false
        this.medicamentsDone = true
      }).catch(error => {
        this.medicamentsError = error.response.data.errors
        this.medicaments = false
        this.medicamentsPending = false
        this.medicamentsDone = false
      })
    },
    getClientPrescribedMedicaments (clientId) {
      this.medicamentsPending = true
      this.medicamentsDone = false
      this.$http.get('client/' + clientId + '/medicament_prescribed').then(response => {
        this.medicaments = response.data
        this.medicamentsPending = false
        this.medicamentsDone = true
      }).catch(error => {
        this.medicamentsError = error.response.data.errors
        this.medicaments = false
        this.medicamentsPending = false
        this.medicamentsDone = false
      })
    },
    getClientUnprescribedMedicaments (clientId) {
      this.medicamentsPending = true
      this.medicamentsDone = false
      this.$http.get('client/' + clientId + '/medicament_unprescribed').then(response => {
        this.medicaments = response.data
        this.medicamentsPending = false
        this.medicamentsDone = true
      }).catch(error => {
        this.medicamentsError = error.response.data.errors
        this.medicaments = false
        this.medicamentsPending = false
        this.medicamentsDone = false
      })
    },
    getVisitUnprescribedMedicaments (visitId) {
      this.medicamentsPending = true
      this.medicamentsDone = false
      this.$http.get('visit/' + visitId + '/medicament_unprescribed').then(response => {
        this.medicaments = response.data
        this.medicamentsPending = false
        this.medicamentsDone = true
      }).catch(error => {
        this.medicamentsError = error.response.data.errors
        this.medicaments = false
        this.medicamentsPending = false
        this.medicamentsDone = false
      })
    },
    postPrescriptionsFromMedicamentsByClient (clientId) {
      this.postPrescriptionsPending = true
      this.postPrescriptionsDone = false
      this.$http.post('client/' + clientId + '/prescribe_medicaments').then(response => {
        this.postPrescriptionsPending = false
        this.postPrescriptionsDone = true
      }).catch(error => {
        this.postPrescriptionsError = error.response.data.errors
        this.postPrescriptionsPending = false
      })
    },
    postPrescriptionsFromMedicamentsByVisit (visitId) {
      this.postPrescriptionsPending = true
      this.postPrescriptionsDone = false
      this.$http.post('visit/' + visitId + '/prescribe_medicaments').then(response => {
        this.postPrescriptionsPending = false
        this.postPrescriptionsDone = true
      }).catch(error => {
        this.postPrescriptionsError = error.response.data.errors
        this.postPrescriptionsPending = false
      })
    },
    getDiagnoses (visitId) {
      this.diagnosesPending = true
      this.diagnosesDone = false
      this.$http.get('visit/' + visitId + '/diagnosis').then(response => {
        this.diagnoses = response.data
        this.diagnosesPending = false
        this.diagnosesDone = true
      }).catch(error => {
        this.diagnosesError = error.response.data.errors
        this.diagnoses = false
        this.diagnosesPending = false
        this.diagnosesDone = true
      })
    },
    getDiseases (search) {
      this.diseasesPending = true
      this.$http.get('icd/disease', {params: {search: search}}).then(response => {
        if (response.status === 204) {
          this.diseases = []
        } else {
          this.diseases = response.data
        }
        this.diseasesPending = false
      }).catch(error => {
        this.diseasesError = error.response.data.errors
        this.diseases = []
        this.diseasesPending = false
      })
      // this.searchDisease({params: {search: search}})
    },
    getMedicalReport (visitId) {
      this.medicalReportLoading = true
      this.$http.get('/visit/' + visitId + '/medical_report').then(response => {
        if (response.status === 200) {
          this.medicalReportOldText = response.data.text
          this.medicalReportText = response.data.text
          console.log('response: ' + response.data)
        }
        this.medicalReportLoading = false
      }).catch(error => {
        this.medicalReportError = error.response.data.errors
        this.medicalReportLoading = false
      })
    },
    postMedicalReport (visitId, medicalReportText) {
      this.medicalReportPending = true
      this.$http.post('/visit/' + visitId + '/medical_report', {text: medicalReportText}, {emulateJSON: true}).then(response => {
        this.medicalReportPending = false
        this.medicalReportDone = true
        this.medicalReportOldText = this.medicalReportText
      }).catch(error => {
        this.medicalReportError = error.response.data.errors
        this.medicalReportPending = false
      })
    },
    postAnamnesisByVisit (visitId, anamnesis) {
      this.anamnesisPending = true
      this.$http.post('/visit/' + visitId + '/anamnesis', anamnesis, {emulateJSON: true}).then(response => {
        this.anamnesisPending = false
        this.anamnesisDone = true
      }).catch(error => {
        this.anamnesisError = error.response.data.errors
        this.anamnesisPending = false
      })
    },
    getVisitsReporting (getParams) {
      this.visitsPending = true
      this.$http.get('contractual_reporting', { params: getParams }).then(response => {
        this.visits = response.data
        this.visitsPending = false
      }).catch(error => {
        this.visitsError = error.response.data.errors
        this.visitsPending = false
      })
    },
    replacer (key, value) {
      if (value === '') {
        return null
      }
      return value
    },
    membershipExpiresSoon (membership) {
      if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
        return true
      } else {
        return false
      }
    },
    hasLoggedUserRole (role) {
      let roles = JSON.parse(this.$ls.get('role'))
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true
        }
      }
      return false
    },
    uploadFile (data, clientId = null, visitId = null) {
      this.uploadPending = true
      this.$http.post('/document/upload', data).then(() => {
        this.uploadDone = true
        this.uploadPending = false
      }).catch(() => {
        this.uploadDone = true
        this.uploadPending = false
      })
    }
  }
}

export default apiMixin



// WEBPACK FOOTER //
// ./src/mixins/index.js